



































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyList from "@/mixins/list";
// import MyForm from '@/mixins/form'

import Add from "./ground_add.vue";
import Edit from "./ground_edit.vue";
import Robot from "./ground_robot.vue";
import GroundCalendar from "./ground_calendar.vue";

@Component({
  components: {
    Add,
    Edit,
    Robot,
    GroundCalendar
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  modalVisible = true;

  robotModalVisible = false;

  calendarModalVisible = false;

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    {
      title: "场地名称",
      dataIndex: "name"
    },
    {
      title: "描述",
      dataIndex: "description"
    },
    {
      title: "状态",
      scopedSlots: { customRender: "status" }
    },
    {
      title: "序号",
      dataIndex: "sn"
    },
    {
      title: "操作",
      scopedSlots: { customRender: "action" }
    }
  ];

  mounted() {
    this.loadData1();
  }

  async loadData1() {
    this.loading = true;
    const res = await this.$store.dispatch("stadium/getStadiumGrounds", {
      stadium_id: this.stadiumId
    });
    if (res && res.Data) {
      this.data = res.Data;
      this.loading = false;
    }
  }

  showAddModal1() {
    this.addModalVisible = true;
  }

  hideAddModal1() {
    this.addModalVisible = false;
    this.loadData1();
  }

  showEditModal1(id: number) {
    this.editId = id;
    this.editModalVisible = true;
  }

  hideEditModal1() {
    this.editModalVisible = false;
    this.loadData1();
  }

  showRobotModal(id: number) {
    this.editId = id;
    this.robotModalVisible = true;
  }

  hideRobotModal() {
    this.robotModalVisible = false;
  }

  showCalendarModal() {
    this.calendarModalVisible = true;
  }

  hideCalendarModal() {
    this.calendarModalVisible = false;
  }

  handleDelete1(id: number) {
    this.$confirm({
      title: "确认信息",
      content: "确定要删除该片场吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/deleteGround", {
          id
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }
}
